<script setup lang="ts">
import { useField, useForm } from 'vee-validate';
import { object, string } from 'zod';
import {
  type SupportTicketCreateRequest,
  useAddSupportTicket,
} from '@/features/supportTickets';
import { useToasts } from '@glow/shared/store/toasts';
import { toTypedSchema } from '@vee-validate/zod';

const emit = defineEmits<{
  (e: 'submitted'): void;
}>();

const validationSchema = toTypedSchema(
  object({
    subject: string().min(3).max(64),
    text: string().min(15).max(512),
  })
);
const { handleSubmit } = useForm({ validationSchema });
const { value: subject, errorMessage: subjectError } =
  useField<string>('subject');
const { value: text, errorMessage: textError } = useField<string>('text');
const { mutate: addSupportTicket } = useAddSupportTicket();
const { showSuccessToast } = useToasts();

const onSubmit = handleSubmit((values) => {
  addSupportTicket(values as SupportTicketCreateRequest, {
    onSuccess: () => {
      showSuccessToast({ title: 'Обращение успешно отправлено' });
      emit('submitted');
    },
  });
});
</script>

<template>
  <AppModal
    title="Задайте вопрос"
    subtitle="Мы с удовольствием поможем вам решить проблему и разобраться с сервисом"
  >
    <form class="d-flex flex-column gap-3" @submit.prevent="onSubmit">
      <AppInput v-model="subject" placeholder="Тема" :error="!!subjectError">
        <template #helper-text>{{ subjectError }}</template>
      </AppInput>
      <AppInput
        v-model="text"
        placeholder="Текст"
        multiline
        counter
        :error="!!textError"
        :rows="5"
        :max-length="512"
      >
        <template #helper-text>{{ textError }}</template>
      </AppInput>
      <AppButton type="submit" fluid>Отправить</AppButton>
    </form>
  </AppModal>
</template>
